export default {
  type: "Feature",
  properties: {
    name: "Мандалговь",
    location: [45.29803870954425, 106.10289276846999],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [103.7823486328125, 45.168967697945575],
        [103.7823486328125, 45.27488643704894],
        [103.798828125, 45.33284041773058],
        [103.77685546875, 45.37144349133922],
        [103.6834716796875, 45.413876460821086],
        [103.623046875, 45.521743896993634],
        [103.623046875, 45.625563438215956],
        [103.71093749999999, 45.7176863579072],
        [103.8262939453125, 45.74836030216746],
        [104.073486328125, 45.74836030216746],
        [104.12841796875, 45.81348649679971],
        [104.1888427734375, 45.98169518512228],
        [104.2437744140625, 46.01603873833416],
        [104.3096923828125, 46.13036330589103],
        [104.43603515624999, 46.12274903582433],
        [104.5513916015625, 46.137976523476574],
        [104.6063232421875, 46.22165245637913],
        [104.65576171875, 46.3810438458062],
        [104.65353012084961, 46.380451731783644],
        [104.776611328125, 46.46056554578543],
        [104.85626220703124, 46.49650154751426],
        [104.96612548828124, 46.59095657312452],
        [105.22979736328125, 46.526745036021474],
        [105.39459228515624, 46.437856895024225],
        [105.4742431640625, 46.543749602738565],
        [105.65826416015625, 46.71350244599995],
        [105.7598876953125, 46.73609593770121],
        [105.84228515625, 46.72480037466717],
        [105.91094970703125, 46.6795944656402],
        [106.05926513671875, 46.63435070293566],
        [106.1224365234375, 46.617374532060765],
        [106.16363525390625, 46.57585481240773],
        [106.68548583984375, 46.574910812684244],
        [106.79946899414062, 46.55980458220511],
        [106.89834594726562, 46.526745036021474],
        [107.03704833984375, 46.43217825300941],
        [107.1002197265625, 46.403776166694634],
        [107.369384765625, 46.41892578708076],
        [107.53692626953125, 46.464822363804686],
        [107.60215759277344, 46.527689873863785],
        [107.63031005859375, 46.542332758884484],
        [107.67494201660156, 46.553666474384535],
        [107.74841308593749, 46.55980458220511],
        [107.78274536132812, 46.56641407568593],
        [107.81845092773438, 46.58576581737151],
        [107.83561706542969, 46.62350543010974],
        [107.84042358398438, 46.68336307047754],
        [107.85072326660155, 46.72291755083757],
        [107.85621643066406, 46.761972680830375],
        [107.9571533203125, 46.77514152351191],
        [107.95663833618164, 46.77455369740659],
        [108.06976318359375, 46.68430518061324],
        [108.19610595703125, 46.64660795992221],
        [108.12057495117188, 46.544694144765536],
        [108.1219482421875, 46.48231911886259],
        [108.16726684570312, 46.43691049578133],
        [108.19198608398438, 46.39998810407942],
        [108.20571899414062, 46.337447097476925],
        [108.15765380859375, 46.27388525189855],
        [108.11370849609375, 46.193140876238004],
        [108.14529418945312, 46.10370875598026],
        [108.21121215820312, 45.99982360564013],
        [108.31146240234375, 45.95019486846407],
        [108.42338562011719, 45.93467676685795],
        [108.55899810791016, 45.94112327491896],
        [108.55899810791016, 45.941362020083915],
        [108.53530883789062, 45.89000815866184],
        [108.49411010742188, 45.769438866203934],
        [108.47763061523438, 45.68795490838444],
        [108.468017578125, 45.590978249451936],
        [108.5174560546875, 45.41773242370463],
        [108.52294921875, 45.36372498305678],
        [108.65272521972655, 45.10793872360393],
        [108.58474731445312, 45.101638366018676],
        [108.511962890625, 45.08564202775547],
        [108.46595764160155, 45.06770141120143],
        [108.4405517578125, 45.02889163330817],
        [108.42269897460938, 44.968684437948376],
        [108.41583251953125, 44.92786297463683],
        [108.41583251953125, 44.88506649401471],
        [108.24966430664062, 44.87630874326681],
        [108.02169799804686, 44.87630874326681],
        [107.91183471679688, 44.86852295681338],
        [107.84042358398438, 44.86852295681338],
        [107.79510498046875, 44.75746105408348],
        [107.76489257812499, 44.66083904265621],
        [107.74017333984375, 44.60904581939581],
        [107.71270751953125, 44.57383915375391],
        [107.68661499023436, 44.554026032095756],
        [107.68730163574217, 44.554270679675696],
        [107.57812499999999, 44.520989167323734],
        [107.49160766601561, 44.49650533109348],
        [107.45040893554688, 44.491607329696045],
        [107.41333007812499, 44.49258696288604],
        [107.33779907226562, 44.512176171071054],
        [107.29660034179686, 44.51609322284931],
        [107.24716186523438, 44.50923820945519],
        [107.18536376953125, 44.491607329696045],
        [106.93130493164062, 44.457309801319305],
        [106.78848266601562, 44.43083793524685],
        [106.68136596679686, 44.38865427337759],
        [106.57699584960938, 44.351350365612305],
        [106.50421142578125, 44.308126684886126],
        [106.42318725585936, 44.29240108529005],
        [106.3641357421875, 44.265854585146684],
        [106.292724609375, 44.21863119293724],
        [106.22817993164061, 44.19795903948531],
        [106.13067626953125, 44.18220395771566],
        [106.06063842773438, 44.17826452922576],
        [105.96176147460938, 44.19303602884215],
        [105.80520629882812, 44.288469027276506],
        [105.76263427734375, 44.31205742666618],
        [105.74066162109375, 44.34644018791789],
        [105.7159423828125, 44.41122141189896],
        [105.5731201171875, 44.55916341529184],
        [105.50445556640625, 44.67744217165251],
        [105.42068481445312, 44.687206496456966],
        [105.12680053710938, 44.687206496456966],
        [104.99633789062499, 44.66962952692013],
        [104.81781005859374, 44.68525376315066],
        [104.71481323242188, 44.715513732021336],
        [104.359130859375, 44.77403648591524],
        [104.26712036132812, 44.83249999349062],
        [104.20944213867186, 44.94924926661153],
        [104.16824340820312, 45.097760877277096],
        [104.10919189453125, 45.20139301126898],
        [104.01031494140625, 45.18397275067566],
        [103.7823486328125, 45.17235628126675],
        [103.7823486328125, 45.168967697945575],
      ],
    ],
  },
};
